import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const EkoBillingFooter = () => {
  const path = useLocation().pathname;
  const [infoVisible, setInfoVisible] = useState<boolean>();

  useEffect(() => {
    if (path === "/login") {
      setInfoVisible(false);
    } else {
      setInfoVisible(true);
    }
  }, [path]);
  return (
    <>
      <footer className="footer">
        {infoVisible ? (
          <div id="info">
            <div className="container">
              <div className="row">
                <div className="col-4">
                  <h3 className="widgettitle">Więcej</h3>
                  <ul id="menu-stopka" className="menu">
                    <li>
                      <a
                        target=""
                        rel="noopener noreferrer"
                        href="https://mzo.wolomin.pl/"
                        role="link"
                      >
                        Witryna MZO Wołomin
                      </a>
                    </li>
                    <li>
                      <a
                        target=""
                        rel="noopener noreferrer"
                        href="http://mzo-wolomin.bip.net.pl/"
                        role="link"
                      >
                        Biuletyn Informacji Publicznej
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://ftp.mzo.wolomin.pl/klauzula_informacyjna.pdf"
                        role="link"
                      >
                        Klauzula Informacyjna
                      </a>
                    </li>
                    <li>
                      <a href="https://mzo.wolomin.pl/kamera" role="link">
                        Kamera online
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-4">
                  <h3 className="widgettitle">Godziny pracy</h3>{" "}
                  <div className="textwidget">
                    <p>
                      <strong>Biuro:</strong>
                      <br />
                      Poniedziałek – Piątek:&nbsp;<strong>7:00–15:00</strong>
                      <br />
                      <strong>Kasa:</strong>
                      <br />
                      Poniedziałek – Piątek:&nbsp;<strong>7:00–14:30</strong>
                    </p>
                    <p>
                      <strong>PSZOK-i:</strong>
                      <br />
                      <strong>ul. Łukasiewicza 4</strong>&nbsp;oraz&nbsp;
                      <strong>Al. Niepodległości 253</strong>
                      <br />
                      Poniedziałek – Piątek:&nbsp;<strong>7:00 – 15:00</strong>
                      <br />
                      Sobota:&nbsp;<strong>10:00 – 16:00</strong>
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <h3 className="widgettitle">
                    Miejski Zakład Oczyszczania w Wołominie Sp. z o.o.
                  </h3>
                  <div className="textwidget">
                    <p>
                      ul. Łukasiewicza 4,
                      <br />
                      05-200 Wołomin
                      <br />
                      tel./faks:{" "}
                      <a
                        href="tel:+48223181492"
                        target=""
                        rel="noreferrer noopener"
                        role="link"
                      >
                        +48 22 318 14 92
                      </a>{" "}
                      /{" "}
                      <a
                        href="tel:+48223181492"
                        target=""
                        rel="noreferrer noopener"
                        role="link"
                      >
                        +48 22 318 14 92
                      </a>
                      <br />
                      e-mail:{" "}
                      <a href="mailto:mzo@mzo.wolomin.pl" role="link">
                        mzo@mzo.wolomin.pl
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <div id="socket" className={infoVisible ? "logged" : "login"}>
          <div className="container">
            © Copyright - Miejski Zakład Oczyszczania w Wołominie
          </div>
        </div>
      </footer>
    </>
  );
};

export { EkoBillingFooter };
